import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import * as constants from "../../Components/constants";
import SendSharpIcon from "@mui/icons-material/SendSharp";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import ThumbUpOffAltOutlinedIcon from "@mui/icons-material/ThumbUpOffAltOutlined";
import ScreenShareOutlinedIcon from "@mui/icons-material/ScreenShareOutlined";
import CommentIcon from "@mui/icons-material/Comment";
import { RWebShare } from "react-web-share";
import { useRouter } from "next/router";
import { Avatar, Box, Paper, Collapse } from "@mui/material";
import style from "../../styles/Post.module.css";
import moment from "moment";
import Swal from "sweetalert2";
import Link from "next/link";
import Image from "next/image";
import { NextSeo } from "next-seo";
import { useMediaQuery } from "@mui/material";
import CoursePreview from "../../Components/SinglePost/CoursePreview/CoursePreview";
import GroupPreview from "../../Components/SinglePost/GroupPreview/GroupPreview";
import RelatedPost from "../../Components/SinglePost/RelatedPost/RelatedPost";
import SignUpModal from "../../Components/ModalContent/SignUpModal/SignUpModal";
import InArticleAds from "../../Components/GoogleAdsense/InArticleAds";
import Footer from "../../Components/Shared/Footer/Footer";
import NodeCache from "node-cache";
import Linkify from "react-linkify";
const cache = new NodeCache({ stdTTL: 60 * 60 });

const IndividualPost = ({ isLoggedIn, data, adsId }) => {
  const image_above = 5662403529;
  //Converting Description for SEO
  var DescriptionHTML = data.title_of_research_article
    ? data.title_of_research_article
    : data.description?.slice(0, 170);
  var Description =
    DescriptionHTML?.replace(/<[^>]+>/g, "") ?? "No Description";

  const [post, setPost] = React.useState(data);
  const [userGeneralInfo, setUserGeneralInfo] = React.useState({});
  const [show, setShow] = React.useState(false);
  //Comment State
  const [moreComment, setMoreComment] = React.useState(false);
  const [commentText, setCommentText] = React.useState("");
  const [moreText, setMoreText] = React.useState("");
  const [comments, setComments] = React.useState([]);

  //sign up modal
  const [openSingUp, setOpenSignUp] = React.useState(false);
  const handleSignUpClose = () => {
    setOpenSignUp(false);
  };

  const handleSignUpOpen = () => {
    setOpenSignUp(true);
  };

  //Route
  const router = useRouter();
  const postId = router.query.post;
  const type = router.query.keyword;
  const baseURL = constants.BASE_URL;
  const BASE_IMG = constants.BASE_IMG;

  //GETTING COMMENT
  const getComment = () => {
    fetch(`${baseURL}/post/comment/${type}/${postId}/`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setComments(data?.slice(0, 1));
        setMoreText(data?.slice(1));
        // setComments(data.reverse());
      });
  };

  React.useEffect(() => {
    getComment();
  }, [postId, type]);

  const handleComment = (e) => {
    fetch(`${baseURL}/post/comment/${type}/${postId}/`, {
      method: "POST",
      headers: {
        Authorization: `Token ${localStorage.getItem("auth_token")}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ content: commentText, is_active: true }),
    })
      .then((res) => {
        res.json();
        if (res.status === 400) {
          Swal.fire({
            title: "Please, write a comment...",
            icon: "warning",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok",
          });
        } else if (res.status === 201) {
          document.getElementById("commentFill").value = "";
          getComment();
        }
      })
      .then((data) => console.log(data))
      .catch((error) => console.log(error));
  };

  React.useEffect(() => {
    fetch(`${baseURL}/user/user-general-info/${localStorage.getItem("id")}`, {
      method: "GET",
      headers: {
        Authorization: `Token ${localStorage.getItem("auth_token")}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => setUserGeneralInfo(data[0]));
  }, []);

  const postRender = () => {
    fetch(`https://researchrider.xyz/post/post/${type}/${postId}/`)
      .then((res) => res.json())
      .then((data) => {
        setPost(data);
      });
  };

  React.useEffect(() => {
    postRender();
  }, [postId, type]);

  const handleLike = (type, postId) => {
    fetch(`${baseURL}/post/like/${type}/${postId}/`, {
      method: "POST",
      headers: {
        Authorization: `Token ${localStorage.getItem("auth_token")}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    }).then((res) => {
      fetch(`https://researchrider.xyz/post/post/${type}/${postId}/`)
        .then((res) => res.json())
        .then((data) => {
          setPost(data);
        });
    });
  };

  setTimeout(() => {
    handleSignUpOpen();
  }, 40000);

  // Google Ads Render
  React.useEffect(() => {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }, []);

  const matches = useMediaQuery("(max-width:768px)");

  if (!post) return <p>No post found data!</p>;
  return (
    <>
      <Container
        fluid={matches}
        className={isLoggedIn ? "" : `${style.main_box}`}
      >
        <NextSeo
          title={`${Description}`}
          description={Description}
          canonical={`https://www.researchrider.com/post/${postId}?keyword=${type}`}
          openGraph={{
            url: `https://www.researchrider.com/post/${postId}?keyword=${type}`,
            title: `${Description}`,
            description: `${Description}`,
            siteName: "www.researchrider.com",
            images: [
              {
                url: `${post.pic_upload}`,
                width: 800,
                height: 600,
                alt: `researchrider ${type} post`,
              },
            ],
          }}
        />

        <Row
          className={`${style.overflow} justify-content-center pt-5 mt-1 g-2`}
        >
          <Col md={7} xl={7} xxl={7}>
            <Paper>
              {post.pic_upload && (
                <Image
                  className={`${style.post_img} border`}
                  width="100%"
                  height="80%"
                  layout="responsive"
                  src={post.pic_upload}
                  alt={post?.group_name}
                  priority
                />
              )}

              <div className={`${style.post}`}>
                <div className="post-user">
                  <div className="post-user-info">
                    <div className="avatar">
                      {isLoggedIn === true ? (
                        <Link
                          href={
                            post.group_name
                              ? `/group/${post.group}`
                              : `/user/${post.user}`
                          }
                        >
                          <a target="_blank">
                            <Avatar
                              sx={{
                                width: 40,
                                height: 40,
                                border: 1,
                                borderColor: "grey.500",
                              }}
                              alt={post.group_name ?? post.user_first_name}
                              src={
                                post.group_profile_pic ?? post.user_profile_pic
                              }
                            />
                          </a>
                        </Link>
                      ) : (
                        <Avatar
                          onClick={() => setOpenSignUp(true)}
                          sx={{
                            width: 40,
                            height: 40,
                            border: 1,
                            borderColor: "grey.500",
                          }}
                          alt={post.group_name ?? post.user_first_name}
                          src={post.group_profile_pic ?? post.user_profile_pic}
                        />
                      )}
                    </div>

                    <div className="profile">
                      {isLoggedIn === true ? (
                        <Link
                          href={
                            post.group_name
                              ? `/group/${post.group}`
                              : `/user/${post.user}`
                          }
                        >
                          <a target="_blank">
                            {post.group_name
                              ? post.group_name
                              : post.user_first_name}
                          </a>
                        </Link>
                      ) : (
                        <>
                          {post.group_name ? (
                            <Link href={`/group/${post.group}`}>
                              {post.group_name
                                ? post.group_name
                                : post.user_first_name}
                            </Link>
                          ) : (
                            <span
                              onClick={() => setOpenSignUp(true)}
                              className={`${style.user_name}`}
                            >
                              {post.group_name
                                ? post.group_name
                                : post.user_first_name}
                            </span>
                          )}
                        </>
                      )}

                      <span className="post-time">
                        <Link
                          href={{
                            pathname: `/post/${post.id}`,
                            query: {
                              keyword: `${
                                post.title_of_research_article
                                  ? "summary"
                                  : "thought"
                              }`,
                            },
                          }}
                        >
                          {moment(post?.created_date).format("DD-MM-YYYY")}
                        </Link>
                      </span>
                    </div>
                  </div>
                </div>

                <span
                  className="text-break"
                  dangerouslySetInnerHTML={{
                    __html: post.description,
                  }}
                ></span>

                {/*--------------- Summary Post ---------------------*/}
                {post.title_of_research_article && (
                  <div className="fb-card-body simple-text-card simple-image-card card-padding ">
                    <div className="p-1">
                      <p>
                        <b>Title of research article</b>
                      </p>
                      {post.title_of_research_article}
                    </div>
                    <div className="p-1">
                      <p>
                        <b>Objective of the study</b>
                      </p>
                      {post.objective_of_the_study}
                    </div>
                    <div className="p-1">
                      <p>
                        <b>Theoretical background</b>
                      </p>
                      {post.theoritical_Background}
                    </div>
                    <div className="p-1">
                      <p>
                        <b>Research gap</b>
                      </p>
                      {post.research_gap}
                    </div>
                    <div className="p-1">
                      <p>
                        <b>Uniqueness of the study</b>
                      </p>
                      {post.uniqueness_of_the_study}
                    </div>
                    <div className="p-1">
                      <p>
                        <b>Data source/sample information</b>
                      </p>
                      {post.data_source_sample_information}
                    </div>
                    <div className="p-1">
                      <p>
                        <b>Research methodology</b>
                      </p>
                      {post.research_methodology}
                    </div>
                    <div className="p-1">
                      <p>
                        <b>Result & discussion</b>
                      </p>
                      {post.result_discussion}
                    </div>
                    <div className="p-1">
                      <p>
                        <b>Validity & reliability of finding</b>
                      </p>
                      {post.validity_reliability_of_finding}
                    </div>
                    <div className="p-1">
                      <p>
                        <b>Usefulness of the finding</b>
                      </p>
                      {post.usefulness_of_the_finding}
                    </div>
                    <div className="p-1">
                      <p>
                        <b>Reference</b>
                      </p>
                      {post.reference}
                    </div>
                    <div className="p-1">
                      <p>
                        <b>Annex</b>
                      </p>
                      {post.annex}
                    </div>
                    <div className="p-1">
                      <p>
                        <b>Keyword</b>
                      </p>
                      {post.keyword}
                    </div>
                    <div className="p-1">
                      {post.file1 && (
                        <Link href={post.file1} passHref legacyBehavior>
                          <a target="_blank" rel="noopener noreferrer">
                            File-1
                          </a>
                        </Link>
                      )}
                      <br />
                      {post.file2 && (
                        <Link href={post.file2} passHref legacyBehavior>
                          <a target="_blank" rel="noopener noreferrer">
                            File-2
                          </a>
                        </Link>
                      )}
                    </div>
                  </div>
                )}
                <div className="inte">
                  <div className="like">
                    <FavoriteRoundedIcon className="like_color" />
                    {post?.likes?.total}
                  </div>
                  <div className="comment">
                    <span>2 comment</span>
                  </div>
                </div>

                <div className="d-flex justify-content-between border-bottom p-1">
                  {isLoggedIn ? (
                    <span
                      className={`${style.action_bar}`}
                      onClick={() =>
                        handleLike(
                          post.title_of_research_article
                            ? "summary"
                            : "thought",
                          post.id
                        )
                      }
                    >
                      {post?.likes?.is_liked ? (
                        <span>
                          <ThumbUpOffAltOutlinedIcon /> Appreciate
                        </span>
                      ) : (
                        <span>
                          <ThumbUpOffAltOutlinedIcon /> Appreciate
                        </span>
                      )}
                    </span>
                  ) : (
                    <span
                      className={`${style.action_bar}`}
                      onClick={() => handleSignUpOpen()}
                    >
                      {post?.likes?.is_liked ? (
                        <span>
                          <ThumbUpOffAltOutlinedIcon /> Appreciate
                        </span>
                      ) : (
                        <span>
                          <ThumbUpOffAltOutlinedIcon /> Appreciate
                        </span>
                      )}
                    </span>
                  )}

                  {isLoggedIn ? (
                    <span className={`${style.action_bar}`}>
                      <CommentIcon /> Comment
                    </span>
                  ) : (
                    <span
                      onClick={() => handleSignUpOpen()}
                      className={`${style.action_bar}`}
                    >
                      <CommentIcon /> Comment
                    </span>
                  )}

                  <RWebShare
                    data={{
                      text: "Web Share - Research Rider",
                      url: `/post/${
                        post.title_of_research_article ? "summary" : "thought"
                      }/${post.id}`,
                      title: "Research Rider",
                    }}
                    onClick={() => console.log("shared successfully!")}
                  >
                    <span className={`${style.action_bar}`}>
                      <ScreenShareOutlinedIcon /> Share
                    </span>
                  </RWebShare>
                </div>

                {comments &&
                  comments.map((comment, index) => (
                    <div key={index} className="users-comments pt-2">
                      <li>
                        <div className="users-comments-avatar">
                          {isLoggedIn ? (
                            <Link href={`/user/${comment.user.id}`}>
                              <Avatar
                                sx={{
                                  width: 40,
                                  height: 40,
                                  border: 1,
                                  borderColor: "grey.500",
                                }}
                                alt="user profile"
                                src={`${BASE_IMG}/media/${comment?.user?.profile_pic}`}
                              />
                            </Link>
                          ) : (
                            <Avatar
                              onClick={() => handleSignUpOpen()}
                              sx={{
                                width: 40,
                                height: 40,
                                border: 1,
                                borderColor: "grey.500",
                              }}
                              alt={post?.latest_comment.user?.first_name}
                              src={post.latest_comment.user.profile_pic}
                            />
                          )}
                        </div>
                        <div className="users-com">
                          {isLoggedIn ? (
                            <Link href={`/user/${comment.user.id}`}>
                              <span className={`${style.comment_user}`}>
                                {post?.latest_comment?.user?.first_name}
                              </span>
                            </Link>
                          ) : (
                            <span
                              className={`${style.comment_user}`}
                              onClick={() => handleSignUpOpen()}
                            >
                              {post?.latest_comment.user?.first_name}
                            </span>
                          )}

                          <Linkify
                            componentDecorator={(
                              decoratedHref,
                              decoratedText,
                              key
                            ) => (
                              <a target="blank" href={decoratedHref} key={key}>
                                {decoratedText}
                              </a>
                            )}
                          >
                            <span
                              style={{
                                wordBreak: "break-all",
                                fontSize: "14px",
                              }}
                            >
                              {post?.latest_comment.content}
                            </span>
                          </Linkify>
                        </div>
                      </li>
                    </div>
                  ))}

                {moreText.length !== 0 && (
                  <small
                    className={moreComment ? "d-none cursor" : "d-block cursor"}
                    onClick={() => setMoreComment(!moreComment)}
                    aria-controls="example-collapse-text"
                    aria-expanded={moreComment}
                  >
                    View more comments
                  </small>
                )}
                <Collapse in={moreComment}>
                  <div id="example-collapse-text">
                    {moreText &&
                      moreText.map((comment, idx) => (
                        <div key={idx} className="users-comments pt-2">
                          <li>
                            <div className="users-comments-avatar">
                              <Avatar
                                sx={{
                                  width: 40,
                                  height: 40,
                                  border: 1,
                                  borderColor: "grey.500",
                                }}
                                alt={post?.latest_comment.user.first_name}
                                src={`${BASE_IMG}/media/${comment?.user?.profile_pic}`}
                              />
                            </div>
                            <div className="users-com">
                              <Link href="#" className="user-name">
                                {comment?.user?.first_name}
                              </Link>

                              <Linkify
                                className="text-break"
                                componentDecorator={(
                                  decoratedHref,
                                  decoratedText,
                                  key
                                ) => (
                                  <a
                                    target="blank"
                                    href={decoratedHref}
                                    key={key}
                                  >
                                    {decoratedText}
                                  </a>
                                )}
                              >
                                <span
                                  style={{
                                    fontSize: "14px",
                                    wordBreak: "break-all",
                                  }}
                                >
                                  {comment?.content}
                                </span>
                              </Linkify>
                            </div>
                          </li>
                        </div>
                      ))}
                  </div>
                </Collapse>
              </div>
              {isLoggedIn === true && (
                <div className="my-com p-2">
                  <div className="users-comments-avatar">
                    <Link href="#">
                      <Avatar
                        sx={{
                          width: 40,
                          height: 40,
                          border: 1,
                          borderColor: "grey.500",
                        }}
                        alt={userGeneralInfo.user_username}
                        src={userGeneralInfo.profile_pic}
                      />
                    </Link>
                  </div>

                  <div className="inp-com">
                    <form onSubmit={handleComment}>
                      <textarea
                        className="form-control"
                        onClick={() => setShow(true)}
                        id="commentFill"
                        onBlur={(e) => setCommentText(e.target.value)}
                        placeholder="Write a comment"
                      />
                      {show ? (
                        <ul className="inp-buttons">
                          <li
                            onClick={() =>
                              handleComment(
                                `${
                                  post.title_of_research_article
                                    ? "summary"
                                    : "thought"
                                }`,
                                post.id
                              )
                            }
                          >
                            <SendSharpIcon color="primary" />
                          </li>
                        </ul>
                      ) : null}
                    </form>
                  </div>
                </div>
              )}
            </Paper>

            <div className={`${style.bannerAds} py-1`}>
              <ins
                className="adsbygoogle"
                style={{ display: "block", textAlign: "center" }}
                data-ad-format="fluid"
                data-ad-layout-key="-ef+6k-30-ac+ty"
                data-ad-client={adsId}
                data-ad-slot="7377674400"
              ></ins>
            </div>

            <Box sx={{ py: 2 }}>
              <RelatedPost groupId={post?.group} postId={postId} />
            </Box>

            <Box>
              <div className={style.bannerAds}>
                <iframe
                  src="//rcm-na.amazon-adsystem.com/e/cm?o=1&p=48&l=ur1&category=audible&banner=0B9F4YZ945EPGMTZ4GG2&f=ifr&linkID=0ba0b35548a87844821ee6ae8537e695&t=researchrider-20&tracking_id=researchrider-20"
                  width="100%"
                  height="90"
                  style={{
                    border: "none",
                    overflow: "hidden",
                    margin: "0 auto",
                    alignItems: "center",
                  }}
                  sandbox="allow-scripts allow-same-origin allow-popups allow-top-navigation-by-user-activation"
                />
              </div>
            </Box>
          </Col>
          <Col md={5} xl={5} xxl={5}>
            <Paper>
              <CoursePreview adsId={adsId} />
            </Paper>
            <div className="my-2">
              <InArticleAds adsId={adsId} slot={image_above} />
            </div>

            <div className="py-3">
              <GroupPreview adsId={adsId} />
            </div>
          </Col>
        </Row>
        <>
          {isLoggedIn === false && (
            <SignUpModal
              open={openSingUp}
              handleClose={handleSignUpClose}
              handleOpen={handleSignUpOpen}
            />
          )}
        </>
      </Container>
      <Footer />
    </>
  );
};

export default IndividualPost;

export async function getServerSideProps(router) {
  const postId = router.query.post;
  const type = router.query.keyword;

  // Check if the API response is already cached
  const cacheKey = `${type}-${postId}`;
  const cachedData = cache[cacheKey];

  if (cachedData) {
    return {
      props: {
        data: cachedData,
      },
    };
  }

  // If the API response is not cached, fetch it from the API
  const res = await fetch(
    `https://researchrider.xyz/post/post/${type}/${postId}/`,
    {
      headers: {
        Accept: "application/json, text/plain, */*",
        "User-Agent": "*",
      },
    }
  );
  const data = await res.json();

  // Cache the API response for future use
  cache[cacheKey] = data;

  return {
    props: {
      data,
    },
  };
}
